import { createFileRoute, stripSearchParams } from "@tanstack/react-router";

// Direct module paths, not the @/customers barrel. validateSearch stays in the
// eager route config, so importing it through the barrel evaluates the barrel
// eagerly and drags CustomersView -> DataTable -> TanStack Table into the entry
// chunk. Same hazard docs/agents/frontend-routing.md documents for
// src/components/index.ts.
import { CustomersPage } from "@/customers/CustomersPage";
import {
  DEFAULT_CUSTOMERS_SEARCH,
  validateCustomersSearch,
} from "@/customers/search";
import { pageTitle } from "@/i18n/title";
import { query } from "@/queries";

export const Route = createFileRoute("/_authed/customers/")({
  validateSearch: validateCustomersSearch,
  search: {
    middlewares: [stripSearchParams(DEFAULT_CUSTOMERS_SEARCH)],
  },
  head: () => pageTitle("Clients"),
  loader: ({ context: { queryClient } }) => {
    // Sync dots. A slow or failed connections read must not hold the list.
    void queryClient
      .query(query.johnDeere.allConnections())
      .catch(() => undefined);
    return queryClient.query(query.customers.accounts());
  },
  component: CustomersPage,
});
